import React from "react";
import Student from "./Student";
import classes from './Students.module.css'


const Students = ({ studentsScore, assessmentsList }) => {

    return (
        <div className={classes.students}>
            {studentsScore && studentsScore.concat().sort((a, b) => a.firstName > b.firstName ? 1 : -1).map((s, index) =>
                <Student key={index} firstName={s.firstName} lastName={s.lastName} studentScoreAverage={s.studentScoreAverage} assessments={s.submissions} assessmentsList={assessmentsList} ></Student>)}
        </div>
    )
}
export default Students;